module.exports = __webpack_public_path__ + "img/logo-fa-left-blue.e4df8d8.svg";